/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import {
  FaEye,
  FaEdit,
  FaTrash,
  FaPlus,
  FaFileAlt,
  FaMoneyBillWave,
  FaChartLine,
  FaRegCopyright,
  FaChevronDown,
} from "react-icons/fa";
import "./AssetManagerDashboard.css";
import { API_END_POINTS } from "../../../../network/apiEndPoint";
import Pagination from "../../../../SharedComponent/Pagination";
import { Navbar, Nav, Container } from "react-bootstrap";
import useDebounce from "../../../../hooks/useDebounce";
import StatCard from "../../../../SharedComponent/Dashboard/StatCard";
import {
  deleteProtected,
  getProtected,
  postProtected,
} from "../../../../network/ApiService";
import { objectToQueryParams } from "../../../../utils/commonHelper";
import { toast } from "react-toastify";
import CreateAssetModal from "../../../../components/common/CreateAssetModal";
import AssetUpdateModal from "../../../../components/common/AssetUpdateModal";
import style from "./AssetManagerDashboard.module.css";
import ViewData from "../../../../components/common/ViewData";
import Button from "../../../../SharedComponent/Button/Button";
import { useTranslation } from "react-i18next";
import Loading from "../../../../SharedComponent/Loading";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAssetData,
  setAllAssets,
} from "../../../../redux/slices/assetsSlice";
import FinanceTableData from "./Finance_Manager/FinanceTableData";
import WarehouseTableData from "./WarehouseManager/WarehouseTableData";
import CreateWarehouseModal from "../../../../components/common/CreateWarehouseModal";
import AssetManagerTable from "./Asset_Manager/AssetManagerTable";
import ViewReport from "../../../../components/common/ViewReport";
import ViewFinance from "../../../../components/common/ViewFinance";
import ViewSales from "../../../../components/common/ViewSales";
import { getLanguage } from "../../../../redux/slices/languageSlice";
import { useNavigate } from "react-router-dom";
import HeroSection from "../../../../components/HeroSection/HeroSection.js";
import {
  CheckCircle,
  ChevronDown,
  Plus,
  Upload,
  UploadCloudIcon,
  X,
  Download,
} from "lucide-react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { baseURL } from "../../../../network/baseUrl";
import ForkliftDetailView from "../../../../components/ForkliftDetailView.jsx";
import { useAppContext } from "../../context/context.js";
const limit = 10;

const AssetManagerDashboard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currentLanguages } = useSelector(getLanguage);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const { allAssets, totalAssets } = useSelector(selectAssetData);

  const {
    filters,
    setFilters,
    CurrentPage,
    setCurrentPage,
    searchQuery,
    setSearchQuery,
  } = useAppContext();
  //  const [searchQuery, setSearchQuery] = useState("");
  const [viewAssetId, setViewAssetId] = useState(null);
  const [showReport, setShowReport] = useState(false);
  const role = localStorage.getItem("userRole");
  const [showFinanceModal, setShowFinanceModal] = useState(false);
  const [selectedAssetId, setSelectedAssetId] = useState(null);
  const [showSalesModal, setShowSalesModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [assetTobeDelete, setAssetTobeDelete] = useState();
  const [dropdownOpen, setDropdownOpen] = useState({
    status: false,
    engine_type: false,
    classification: false,
    generic: false,
  });
  const [uploadErrors, setUploadErrors] = useState([]);
  const [showUploadErrorModal, setShowUploadErrorModal] = useState(false);
  const [updatedAssets, setUpdatedAssets] = useState([]);
  const [isExportingPDF, setIsExportingPDF] = useState(false);

  const useClickOutside = (ref, callback) => {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          callback();
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, callback]);
  };

  useEffect(() => {
    const handleGlobalClick = (event) => {
      // Check if click is outside any dropdown
      const isClickInsideDropdown =
        sortDropdownRef.current?.contains(event.target) ||
        statusDropdownRef.current?.contains(event.target) ||
        engineTypeDropdownRef.current?.contains(event.target) ||
        classificationDropdownRef.current?.contains(event.target);

      if (!isClickInsideDropdown) {
        setDropdownOpen({
          status: false,
          engine_type: false,
          classification: false,
          generic: false,
        });
      }
    };

    document.addEventListener("click", handleGlobalClick, true);
    document.addEventListener("touchstart", handleGlobalClick, true);

    return () => {
      document.removeEventListener("click", handleGlobalClick, true);
      document.removeEventListener("touchstart", handleGlobalClick, true);
    };
  }, []);

  const sortDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const engineTypeDropdownRef = useRef(null);
  const classificationDropdownRef = useRef(null);

  useClickOutside(sortDropdownRef, () => {
    setDropdownOpen((prev) => ({ ...prev, generic: false }));
  });

  useClickOutside(statusDropdownRef, () => {
    setDropdownOpen((prev) => ({ ...prev, status: false }));
  });

  useClickOutside(engineTypeDropdownRef, () => {
    setDropdownOpen((prev) => ({ ...prev, engine_type: false }));
  });

  useClickOutside(classificationDropdownRef, () => {
    setDropdownOpen((prev) => ({ ...prev, classification: false }));
  });

  const allDropdownsRef = useRef(null);

  useClickOutside(allDropdownsRef, () => {
    setDropdownOpen({
      status: false,
      engine_type: false,
      classification: false,
      generic: false,
    });
  });

  const sortOptions = [
    { type: "Sort", value: "", order: 1 },
    { type: "", value: "", order: 1 },
    { type: "Relevance", value: "Latest First", order: 1 },
    { type: "Latest first", value: "Latest First", order: 1 },
    { type: "Price (ascending)", value: "end_user_price", order: 0 },
    { type: "Price (descending)", value: "end_user_price", order: 1 },
    { type: "Capacity (ascending)", value: "capacity", order: 0 },
    { type: "Capacity (descending)", value: "capacity", order: 1 },
    { type: "Lifting height (ascending)", value: "lift_height_mm", order: 0 },
    { type: "Lifting height (descending)", value: "lift_height_mm", order: 1 },
    { type: "Year (ascending)", value: "year_of_manufacture", order: 0 },
    { type: "Year (descending)", value: "year_of_manufacture", order: 1 },
    { type: "Location (a-z)", value: "location", order: 0 },
    { type: "Location (z-a)", value: "location", order: 1 },
  ];

  const [isOpenUploadModel, setIsOpenUploadModel] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const classificationOptions = [
    // {
    //   value: "",
    //   option: t("assets.fields.selectClassification"),
    // },
    { value: "Other", option: "Other" },
    {
      value: "Rough-terrain-forklift",
      option: "Rough-terrain-forklift",
    },
    {
      value: "Container-Stacker",
      option: "Container-Stacker",
    },
    { value: "Reach-stacker", option: "Reach-stacker" },
    {
      value: "Terminal tractor",
      option: "Terminal tractor",
    },
    { value: "Tractor", option: "Tractor" },
    { value: "Trailer", option: "Trailer" },
    {
      value: "Electric platform trucks",
      option: "Electric platform trucks",
    },
    {
      value: "Electric 3-wheel",
      option: "Electric 3-wheel",
    },
    {
      value: "Electric 4-wheel",
      option: "Electric 4-wheel",
    },
    {
      value: "Diesel Forklift",
      option: "Diesel Forklift",
    },
    {
      value: "Compact Forklift Truck",
      option: "Compact Forklift Truck",
    },
    { value: "LPG Forklift", option: "LPG Forklift" },
    { value: "Pallet truck", option: "Pallet truck" },
    {
      value: "Pallet Trucks Sit-down",
      option: "Pallet Trucks Sit-down",
    },
    {
      value: "Scissor elevating truck platform",
      option: "Scissor elevating truck platform",
    },
    {
      value: "Lift trucks with scales",
      option: "Lift trucks with scales",
    },
    {
      value: "Hand pallet truck",
      option: "Hand pallet truck",
    },
    {
      value: "Horizontal order picker",
      option: "Horizontal order picker",
    },
    {
      value: "Vertical order picker",
      option: "Vertical order picker",
    },
    {
      value: "High-lift pallet truck",
      option: "High-lift pallet truck",
    },
    {
      value: "Stacker stand-on",
      option: "Stacker stand-on",
    },
    {
      value: "High lift pallet trucks sit-down",
      option: "High lift pallet trucks sit-down",
    },
    { value: "Reach truck", option: "Reach truck" },
    {
      value: "Narrow aisle truck",
      option: "Narrow aisle truck",
    },
    {
      value: "Telescopic forklift, fixed",
      option: "Telescopic forklift, fixed",
    },
    {
      value: "Telescopic forklift, rotating",
      option: "Telescopic forklift, rotating",
    },
    {
      value: "Four-way loader",
      option: "Four-way loader",
    },
    {
      value: "Four-way reachtruck",
      option: "Four-way reachtruck",
    },
    { value: "Sideloader", option: "Sideloader" },
    {
      value: "Truck mounted forklift",
      option: "Truck mounted forklift",
    },
    {
      value: "Tugger-train-trailer",
      option: "Tugger-train-trailer",
    },
    { value: "CNG-Forklift", option: "CNG-Forklift" },
    {
      value: "Gasoline-Forklift",
      option: "Gasoline-Forklift",
    },
    {
      value: "Electric stairclimber",
      option: "Electric stairclimber",
    },
    {
      value: "Counterbalance forklift",
      option: "Counterbalance forklift",
    },
  ];

  const handleFileUpload = async (file) => {
    if (!uploadedFile) {
      toast.error(t("dashboardToasters.selectFileToupload"));
      return;
    }
    const formData = new FormData();
    formData.append("attachment", uploadedFile);
    setUploading(true);
    try {
      const url = `${baseURL}/assets/book-value-history/`;
      const response = await postProtected(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("response after uploading files  = ", response);
      toast.success(t("dashboardToasters.fileUploadSuccess"));

      let updated = [];
      let notFoundAssets = [];
      // Parse updated count from message
      if (response.message) {
        const match = response.message.match(/(\d+)\sassets?\supdated/i);
        if (match && match[1] !== "0") {
          updated = Array.from(
            { length: Number(match[1]) },
            (_, i) => `asset ${i + 1}`
          );
        }
      }

      // Extract asset IDs from error messages
      notFoundAssets = response.errors
        ? response.errors
          .map((err) => {
            const match = err.match(/asset_id '([^']+)'/i);
            return match ? match[1] : null;
          })
          .filter(Boolean)
        : [];

      setUpdatedAssets(updated);
      setUploadErrors(notFoundAssets);
      if (notFoundAssets.length > 0 || updated.length === 0) {
        setShowUploadErrorModal(true);
      } else {
        setShowUploadErrorModal(false);
      }
      fetchAssets();
    } catch (error) {
      // Handle 400 error (bad request, e.g., no serial numbers)
      if (error.response?.status === 400 && error.response?.data?.errors) {
        setUpdatedAssets([]);
        const notFoundAssets = error.response.data.errors
          ? error.response.data.errors
            .map((err) => {
              const match = err.match(/asset_id '([^']+)'/i);
              return match ? match[1] : null;
            })
            .filter(Boolean)
          : [];
        setUploadErrors(notFoundAssets);
        setShowUploadErrorModal(true);
        fetchAssets();
        setUploading(false);
        setUploadedFile(null);
        setIsOpenUploadModel(false);
        return;
      }
      if (error.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }
      if (error.response?.status === 403) {
        toast.error(t("dashboardToasters.dontHavePermissionToUploadFile"));
        return;
      }
      console.error(
        t("dashboardToasters.genricError"),
        error.response?.data || error.message
      );
    } finally {
      setUploading(false);
      setUploadedFile(null);
      setIsOpenUploadModel(false);
    }
  };

  const removeUploadError = (assetId) => {
    setUploadErrors((prev) => prev.filter((id) => id !== assetId));
  };

  const exportUploadErrorsToPDF = async () => {
    if (isExportingPDF) return;

    setIsExportingPDF(true);
    try {
      // Create a temporary div with the content to export
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      tempDiv.style.top = '-9999px';
      tempDiv.style.width = '800px';
      tempDiv.style.backgroundColor = 'white';
      tempDiv.style.padding = '20px';
      tempDiv.style.fontFamily = 'Arial, sans-serif';

      // Add title
      const title = document.createElement('h2');
      title.textContent = 'Assets Not Uploaded - Book Value History';
      title.style.fontSize = '24px';
      title.style.fontWeight = 'bold';
      title.style.marginBottom = '20px';
      title.style.color = '#1f2937';
      tempDiv.appendChild(title);

      // Add updated assets info if any
      if (updatedAssets.length > 0) {
        const updatedInfo = document.createElement('div');
        updatedInfo.style.marginBottom = '15px';
        updatedInfo.style.color = '#059669';
        updatedInfo.style.fontSize = '16px';
        updatedInfo.innerHTML = `${updatedAssets.length} ${updatedAssets.length === 1 ? 'asset updated' : 'assets updated'}`;
        tempDiv.appendChild(updatedInfo);
      }

      // Add subtitle
      const subtitle = document.createElement('p');
      subtitle.textContent = 'The following assets could not be uploaded:';
      subtitle.style.fontSize = '16px';
      subtitle.style.marginBottom = '15px';
      subtitle.style.color = '#374151';
      tempDiv.appendChild(subtitle);

      // Create table
      const table = document.createElement('table');
      table.style.width = '100%';
      table.style.borderCollapse = 'collapse';
      table.style.border = '1px solid #d1d5db';

      // Table header
      const thead = document.createElement('thead');
      const headerRow = document.createElement('tr');
      headerRow.style.backgroundColor = '#f9fafb';

      const serialNoHeader = document.createElement('th');
      serialNoHeader.textContent = 'Serial No not found';
      serialNoHeader.style.padding = '12px';
      serialNoHeader.style.border = '1px solid #d1d5db';
      serialNoHeader.style.textAlign = 'left';
      serialNoHeader.style.fontWeight = 'bold';
      headerRow.appendChild(serialNoHeader);

      const actionHeader = document.createElement('th');
      actionHeader.textContent = 'Action';
      actionHeader.style.padding = '12px';
      actionHeader.style.border = '1px solid #d1d5db';
      actionHeader.style.textAlign = 'center';
      actionHeader.style.fontWeight = 'bold';
      headerRow.appendChild(actionHeader);

      thead.appendChild(headerRow);
      table.appendChild(thead);

      // Table body
      const tbody = document.createElement('tbody');
      uploadErrors.forEach((assetId) => {
        const row = document.createElement('tr');

        const serialNoCell = document.createElement('td');
        serialNoCell.textContent = assetId;
        serialNoCell.style.padding = '12px';
        serialNoCell.style.border = '1px solid #d1d5db';
        row.appendChild(serialNoCell);

        const actionCell = document.createElement('td');
        actionCell.style.padding = '12px';
        actionCell.style.border = '1px solid #d1d5db';
        actionCell.style.textAlign = 'center';
        actionCell.innerHTML = '✕';
        actionCell.style.color = '#dc2626';
        actionCell.style.fontSize = '18px';
        actionCell.style.fontWeight = 'bold';
        row.appendChild(actionCell);

        tbody.appendChild(row);
      });

      table.appendChild(tbody);
      tempDiv.appendChild(table);

      // Add to DOM temporarily
      document.body.appendChild(tempDiv);

      // Generate PDF
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        width: 800,
        height: tempDiv.scrollHeight
      });

      const imgData = canvas.toDataURL('image/jpeg', 0.8);
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      const pageHeight = pdf.internal.pageSize.getHeight();
      let heightLeft = pdfHeight;
      let position = 0;

      pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, pdfHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - pdfHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, pdfHeight);
        heightLeft -= pageHeight;
      }

      // Save PDF
      const fileName = `upload-errors-${new Date().toISOString().split('T')[0]}.pdf`;
      pdf.save(fileName);

      // Clean up
      document.body.removeChild(tempDiv);

    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Error generating PDF. Please try again.');
    } finally {
      setIsExportingPDF(false);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
  };
  // Fetch assigned assets
  const fetchAssets = async () => {
    setShowLoader(true);
    try {
      console.log("fetch assets called  .... ");
      const query = {
        page: CurrentPage + 1,
        page_size: limit,
        language: currentLanguages,
      };
      if (filters.status) query.status = filters.status;
      if (filters.engine_type) query.engine_type = filters.engine_type;
      if (filters.classification) query.classification = filters.classification;
      if (filters.filter)
        query.order_by = filters.filter?.value || "Latest First";
      console.log("----> filter ", filters.filter);
      if (filters.filter) {
        query.od = filters?.filter.order;
      }

      if (searchQuery !== undefined || searchQuery !== null) {
        if (!isNaN(parseInt(searchQuery?.[0]))) {
          // query.asset_id = searchQuery;
          query.search_param = searchQuery;
          console.log("query object = ", query);
        } else if (searchQuery?.length > 0) {
          query.description = searchQuery;
          query.search_param = searchQuery;
        }
      }
      const newQuery = objectToQueryParams(query);
      const url = `${API_END_POINTS.assets}?${newQuery}`;
      const response = await getProtected(url);

      console.log("response of fetch assets api  = ", response);
      if (response) {
        console.log("filter = ", filters.filter);
        const { count, previous, next, results } = response;
        const data = {
          count,
          previous,
          next,
          results: [...results],
        };
        dispatch(setAllAssets(data));
        // setAssets(response.results);
        // setAssetCount(response.count);
        setShowLoader(false);
      }
    } catch (e) {
      if (e.response?.status === 404) {
        setCurrentPage(0);
        return;
      }
      if (e.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }
      const message = e?.response?.data?.messages;
      if (message && message?.[0]?.message) {
        toast.error(t("assets.messages.fetchError"));
      }
      setShowLoader(false);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    fetchAssets();
  }, [
    CurrentPage,
    filters.status,
    currentLanguages,
    filters.engine_type,
    filters.classification,
    filters.filter,
  ]);

  const debouncedQuery = useDebounce(searchQuery, 500);

  useEffect(() => {
    if (debouncedQuery !== undefined || debouncedQuery !== null) {
      // setCurrentPage((pre) => 0);
      fetchAssets();
    }
  }, [debouncedQuery]);

  // Handle asset deletion with translations
  const handleDeleteAsset = async (asset) => {
    // if (!window.confirm(t("assets.messages.deleteConfirm"))) {
    //   return;
    // }
    setAssetTobeDelete(asset);
    setShowDeleteModal(true);

    // try {
    //   const url = `${API_END_POINTS.assets}${asset.id}/`;
    //   const response = await deleteProtected(url);
    //   if (response) {
    //     fetchAssets();
    //     refreshDashboard();
    //     toast.success(t("assets.messages.deleteSuccess"));
    //   }
    // } catch (e) {
    //   console.log(e);
    //   const message = e?.response?.data?.messages;
    //   if (message && message?.[0]?.message) {
    //     toast.error(t("assets.messages.deleteError"));
    //   }
    // }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFile(file);
    }
  };

  const closeModal = () => {
    setIsOpenUploadModel(false);
    setUploadedFile(null);
    setUploading(false);
  };

  const toggleDropdown = (key) => {
    setDropdownOpen((prev) => ({
      status: false,
      engine_type: false,
      classification: false,
      generic: false,
      [key]: !prev[key],
    }));
  };

  const confirmDeleteAsset = async () => {
    setShowDeleteModal(false);
    console.log("delete modal called ....");
    const asset = assetTobeDelete;
    try {
      const url = `${API_END_POINTS.assets}${asset.id}/`;
      const response = await deleteProtected(url);
      if (response) {
        fetchAssets();
        refreshDashboard();
        toast.success(t("assets.messages.deleteSuccess"));
      }
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }

      console.log(e);
      const message = e?.response?.data?.messages;
      if (message && message?.[0]?.message) {
        toast.error(t("assets.messages.deleteError"));
      }
    }
  };

  const getDashboard = async () => {
    try {
      const url = API_END_POINTS.dashboard;
      const response = await getProtected(url);
      if (response) {
        // Update your state or dispatch actions as needed
      }
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }
      console.log(e);
      const message = e?.response?.data?.messages;
      if (message && message?.[0]?.message) {
        toast.error(t("dashboard.errors.fetchFailed"));
      }
    }
  };

  const refreshDashboard = () => {
    getDashboard(); // Call the function to refresh data
  };

  const handleViewFinance = (assetId) => {
    setSelectedAssetId(assetId);
    setShowFinanceModal(true);
  };

  const handleEditClick = (asset) => {
    navigate(`/edit-asset/${asset.id}`, { state: { assetData: asset } });
  };

  return (
    <>
      <div className="relative  w-full max-w-full  flex flex-col min-h-screen  bg-gray-50">
        {isOpenUploadModel && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">
                  {t("uploadBookValueModel.uploadBookValue")}
                </h3>
                <button
                  onClick={closeModal}
                  className="text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 rounded-full p-1"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="p-6 flex flex-col gap-4">
                {
                  <>
                    <div
                      className={`relative border-2 border-dashed rounded-lg p-8 text-center transition-colors `}
                    >
                      <input
                        type="file"
                        accept=".xlsx"
                        onChange={handleFileChange}
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      />

                      <Upload className="mx-auto h-12 w-12 text-gray-400 mb-4" />
                    </div>
                  </>
                }
                {uploadedFile && <p>{uploadedFile?.name}</p>}
                <button
                  onClick={handleFileUpload}
                  disabled={uploading}
                  className={`flex items-center gap-2 px-3 py-2 rounded transition-colors ${
                    uploading
                      ? "cursor-not-allowed bg-gray-400 text-white"
                      : "cursor-pointer bg-blue-600 hover:bg-blue-700 text-white"
                  }`}
                >
                  {uploading ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      Uploading...
                    </>
                  ) : (
                    <>
                      <Upload className="h-4 w-4" />
                      {t("uploadBookValueModel.upload")}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Statistics Cards */}
        {/* style={{ height: "auto !important" }} */}
        <HeroSection {...{ t, handleSearch, setSearchQuery, searchQuery }} />
        <Loading loading={showLoader} text={t("common.loading.assets")} />
        {/* Filters and Search */}
        {/*  p-4 -lg */}
        <div className="w-full bg-white px-4 md:py-4 -lg   shadow-sm">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4">
            <div className="w-full md:w-auto mb-4 md:mb-0">
              <h1 className="text-xl font-bold">
                {/* {t("createAsset.buttons.YourTickets")} */}
              </h1>
            </div>

            {/* //flex flex-col sm:flex-row w-full md:w-auto */}

            <div className=" w-full ">
              {(role === "admin" ||
                role === "asset_manager" ||
                role === "warehouse_manager") && (
                  <>
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                      {/* Left section - Filters */}
                      <div className=" flex flex-col sm:flex-col lg:flex-row gap-2 lg:gap-4">
                        {/* Sort Dropdown */}
                        <div
                          ref={sortDropdownRef}
                          className="relative inline-block text-left w-full lg:w-64"
                        >
                          <div>
                            <button
                              type="button"
                              className="flex items-center justify-between w-full px-4 py-2 text-left bg-white border border-gray-300 -md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                              onClick={() => toggleDropdown("generic")}
                            >
                              <span className="flex items-center">
                                {!filters?.filter?.type && (
                                  <span className="mr-2">{t(`sort.Sort`)}</span>
                                )}
                                <span className="">
                                  {filters?.filter?.type?.length > 10
                                    ? filters?.filter?.type?.slice(0, 10) + ".."
                                    : filters?.filter?.type}
                                </span>
                              </span>
                              <FaChevronDown
                                className={`ml-2 transition-transform duration-200 ${dropdownOpen.generic ? "rotate-180" : ""
                                  }`}
                              />
                            </button>
                          </div>

                          {dropdownOpen?.generic && (
                            <div className="origin-top-right absolute right-0 mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
                              <div className="py-1 max-h-64 overflow-y-auto flex flex-col items-start">
                                {sortOptions.map(
                                  (option, index) =>
                                    option?.type !== "" && (
                                      <button
                                        key={index}
                                        className={`px-4 py-2 w-full text-start hover:bg-gray-100 cursor-pointer `}
                                        onClick={() => {
                                          // setCurrentPage(0);
                                          setFilters({
                                            ...filters,
                                            filter: option,
                                          });
                                          setDropdownOpen((prev) => ({
                                            ...prev,
                                            generic: false,
                                          }));
                                        }}
                                      >
                                        {t(`sort.${option.type}`)}
                                      </button>
                                    )
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Status Dropdown */}
                        <div
                          ref={statusDropdownRef}
                          className="relative w-full lg:w-48"
                        >
                          <button
                            type="button"
                            className="flex items-center justify-between w-full px-4 py-2 text-left bg-white border border-gray-300 -md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onClick={() => toggleDropdown("status")}
                          >
                            <span>{filters.status || "Status"}</span>
                            <FaChevronDown
                              className={`ml-2 transition-transform duration-200 ${dropdownOpen.status ? "rotate-180" : ""
                                }`}
                            />
                          </button>

                          {dropdownOpen.status && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 -md shadow-lg">
                              <ul className="py-1 overflow-hidden">
                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                  onClick={() => {
                                    // setCurrentPage(0);
                                    setFilters({ ...filters, status: "" });
                                    setDropdownOpen((prev) => ({
                                      ...prev,
                                      status: false,
                                    }));
                                  }}
                                >
                                  Status
                                </li>
                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                  onClick={() => {
                                    // setCurrentPage(0);
                                    setFilters({ ...filters, status: "New" });
                                    setDropdownOpen((prev) => ({
                                      ...prev,
                                      status: false,
                                    }));
                                  }}
                                >
                                  {t("assets.status.New")}
                                </li>
                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                  onClick={() => {
                                    // setCurrentPage(0);
                                    setFilters({ ...filters, status: "Used" });
                                    setDropdownOpen((prev) => ({
                                      ...prev,
                                      status: false,
                                    }));
                                  }}
                                >
                                  {t("assets.status.Used")}
                                </li>

                                {/* <li
          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => {
            setCurrentPage(0);
            setFilters({ ...filters, status: 'Rental' });
            setDropdownOpen(false);
          }}
        >
          {t("assets.status.Rental")}
        </li> */}
                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                  onClick={() => {
                                    // setCurrentPage(0);
                                    setFilters({
                                      ...filters,
                                      status: "Short Time Hire",
                                    });
                                    setDropdownOpen((prev) => ({
                                      ...prev,
                                      status: false,
                                    }));
                                  }}
                                >
                                  {/* {t("assets.status.Rental")} */}
                                  {t("assets.status.shortTermHire")}
                                </li>

                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                  onClick={() => {
                                    // setCurrentPage(0);
                                    setFilters({ ...filters, status: "Demo" });
                                    setDropdownOpen((prev) => ({
                                      ...prev,
                                      status: false,
                                    }));
                                  }}
                                >
                                  {t("assets.status.Demo")}
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>

                        {/* Engine Type Dropdown */}
                        <div
                          ref={engineTypeDropdownRef}
                          className="relative w-full lg:w-48"
                        >
                          <button
                            type="button"
                            className="flex items-center justify-between w-full px-4 py-2 text-left bg-white border border-gray-300 -md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onClick={() => toggleDropdown("engine_type")}
                          >
                            <span>
                              {filters?.engine_type
                                ? t(`engineTypes.${filters.engine_type}`) ||
                                filters.engine_type
                                : t("filters.engineType")}
                            </span>
                            <FaChevronDown
                              className={`ml-2 transition-transform duration-200 ${dropdownOpen.engine_type ? "rotate-180" : ""
                                }`}
                            />
                          </button>

                          {dropdownOpen.engine_type && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 -md shadow-lg max-h-96 overflow-y-auto">
                              <ul className="py-1 overflow-hidden">
                                {[
                                  "Electric",
                                  "LPG",
                                  "manual/none",
                                  "Diesel",
                                  "Gasoline",
                                  "Natural gas (CNG)",
                                  "Hybrid",
                                  "Li-Ion",
                                  "Fuel-Cell",
                                ].map((type) => (
                                  <li
                                    key={type}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                      setFilters({
                                        ...filters,
                                        engine_type: type,
                                      });
                                      setDropdownOpen((prev) => ({
                                        ...prev,
                                        engine_type: false,
                                      }));
                                    }}
                                  >
                                    {t(`engineTypes.${type}`)}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>

                        {/* Classification Dropdown */}
                        <div
                          ref={classificationDropdownRef}
                          className="relative w-full lg:w-48"
                        >
                          <button
                            type="button"
                            className="flex items-center justify-between w-full px-4 py-2 text-left bg-white border border-gray-300 -md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onClick={() => toggleDropdown("classification")}
                          >
                            <span>
                              {filters?.classification
                                ? t(`classification.${filters.classification}`) ||
                                filters.classification
                                : t("filters.classification")}
                            </span>
                            <FaChevronDown
                              className={`ml-2 transition-transform duration-200 ${dropdownOpen.classification ? "rotate-180" : ""
                                }`}
                            />
                          </button>

                          {dropdownOpen.classification && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 -md shadow-lg max-h-96 overflow-y-auto">
                              <ul className="py-1 overflow-hidden">
                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                  onClick={() => {
                                    // setCurrentPage(0);
                                    setFilters({
                                      ...filters,
                                      classification: "",
                                    });
                                    setDropdownOpen((prev) => ({
                                      ...prev,
                                      classification: false,
                                    }));
                                  }}
                                >
                                  {t("filters.classification")}
                                </li>
                                {classificationOptions.map((option, index) => {
                                  return (
                                    <li
                                      key={index}
                                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                      onClick={() => {
                                        // setCurrentPage(0);
                                        setFilters({
                                          ...filters,
                                          classification: option.value,
                                        });
                                        setDropdownOpen((prev) => ({
                                          ...prev,
                                          classification: false,
                                        }));
                                      }}
                                    >
                                      {t(`classification.${option.value}`)}
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Right section - Action Buttons */}
                      <div className="  flex flex-col sm:flex-col lg:flex-row lg:items-center gap-2 lg:gap-4">
                        <button
                          onClick={() => {
                            navigate("/utilization-report");
                          }}
                          className="flex items-center gap-2 px-4 py-2 text-white bg-blue-600 -md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full lg:w-auto justify-center lg:justify-start"
                        >
                          <FaFileAlt /> {t("dashboard.utilzationReport")}
                        </button>

                        <ViewReport
                          showModal={showReport}
                          setShowModal={setShowReport}
                        />
                        {/*
    <button
      onClick={() => {
        setShowReport(true);
      }}
      className="flex items-center gap-2 px-4 py-2 text-white bg-blue-600 -md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full lg:w-auto justify-center lg:justify-start"
    >
      <FaFileAlt /> {t("dashboard.viewReport")}
    </button> */}

                        <button
                          className="flex items-center gap-2 px-4 py-2 text-white bg-blue-600 -md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full lg:w-auto justify-center lg:justify-start"
                          onClick={() => {
                            if (role === "admin" || role === "asset_manager") {
                              navigate("/create-asset");
                            } else {
                              setShowModal(true);
                            }
                          }}
                        >
                          <FaPlus />
                          {t("assets.actions.create")}
                        </button>
                      </div>
                    </div>
                  </>

                  // engine type
                )}

              <div className="flex  flex-wrap gap-2">
                {role === "finance_manager" && (
                  <>
                    <button
                      onClick={() => {
                        setIsOpenUploadModel(true);
                      }}
                      className="flex items-center gap-2 px-4 py-2 text-white bg-blue-600 -md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <UploadCloudIcon />{" "}
                      {t("uploadBookValueModel.uploadBookValue")}
                    </button>

                    <button
                      onClick={() => setShowFinanceModal(true)}
                      className="flex items-center gap-2 px-4 py-2 text-white bg-blue-600 -md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <FaMoneyBillWave /> {t("assets.actions.viewFinance")}
                    </button>
                  </>
                )}

                {/* {role !== "finance_manager" && (
              <button
                onClick={() => {
                  if(role === "asset_manager"){
                    navigate("/create-asset")
                  } else {
                    setShowModal(true)
                  }
                }}
                className="flex items-center gap-2 px-4 py-2 text-white bg-blue-600 -md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <FaPlus />
                {role === "asset_manager" || role === "customer_manager"
                  ? t("assets.actions.create")
                  : t("warehouse.actions.add")}
              </button>
            )}
             */}
                {role === "customer_manager" && (
                  <button
                    onClick={() => setShowSalesModal(true)}
                    className="flex items-center gap-2 px-4 py-2 text-white bg-blue-600 -md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <FaChartLine /> {t("assets.actions.viewSales")}
                  </button>
                )}
              </div>
            </div>
          </div>

          {role === "finance_manager" && (
            <>
              <FinanceTableData
                totalAssets={totalAssets}
                allAssets={allAssets}
                limit={limit}
                currentPage={CurrentPage}
                setCurrentPage={setCurrentPage}
                setViewAssetId={setViewAssetId}
                setSelectedAsset={setSelectedAsset}
                setShowEditModal={setShowEditModal}
                handleDeleteAsset={handleDeleteAsset}
                onViewFinance={handleViewFinance}
              />
              <ViewFinance
                showModal={showFinanceModal}
                setShowModal={setShowFinanceModal}
                assetId={selectedAssetId}
              />
            </>
          )}
          {role === "warehouse_manager" && (
            <>
              <WarehouseTableData
                totalAssets={totalAssets}
                allAssets={allAssets}
                limit={limit}
                currentPage={CurrentPage}
                setCurrentPage={setCurrentPage}
                setViewAssetId={setViewAssetId}
                setSelectedAsset={setSelectedAsset}
                setShowEditModal={setShowEditModal}
                handleDeleteAsset={handleDeleteAsset}
              />
            </>
          )}
          {(role === "admin" || role === "asset_manager") && (
            <AssetManagerTable
              totalAssets={totalAssets}
              d
              allAssets={allAssets}
              limit={limit}
              currentPage={CurrentPage}
              setCurrentPage={setCurrentPage}
              setViewAssetId={setViewAssetId}
              handleDeleteAsset={handleDeleteAsset}
            />
          )}
          {/* Assets Table */}
          {role === "customer_manager" && (
            <div className={style["assets-table-container"]}>
              <table className={style["assets-table"]}>
                <thead>
                  <tr>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("assets.fields.id")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "150px" }}>
                        {t("assets.fields.description")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("assets.fields.status")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("assets.fields.brand")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("assets.fields.model")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("assets.fields.warehouse")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("assets.fields.purchaseDate")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("assets.fields.operatingHours")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("common.actions")}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allAssets?.map((asset) => (
                    <tr key={asset.id}>
                      <td>{asset.id}</td>
                      <td>{asset.description}</td>
                      <td>
                        <div
                          className={`${style["status-badge"]} ${style[
                            asset.status === "Miete"
                              ? "completed"
                              : asset.status === "Used" ||
                                asset.status === "Gebraucht"
                                ? "in_progress"
                                : "new"
                            ]
                            }`}
                        >
                          {asset.status}
                        </div>
                      </td>
                      <td>{asset.brand}</td>
                      <td>{asset.model}</td>
                      <td style={{ textAlign: "center" }}>{asset.warehouse}</td>
                      <td>{asset.purchase_date}</td>
                      <td>{asset.operating_hours}</td>
                      <td>
                        <div className={style["action-buttons"]}>
                          <button
                            className={style["btn-view"]}
                            onClick={() => setViewAssetId(asset.id)}
                            title={t("assets.actions.view")}
                          >
                            <FaEye />
                          </button>
                          <button
                            className={style["btn-edit"]}
                            onClick={() => handleEditClick(asset)}
                            title={t("assets.actions.edit")}
                          >
                            <FaEdit />
                          </button>
                          <button
                            className={style["btn-delete"]}
                            onClick={() => handleDeleteAsset(asset)}
                            title={t("assets.actions.delete")}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  margin: "15px 0",
                  justifyContent: "space-around",
                }}
              >
                <Pagination
                  totalItems={totalAssets}
                  setItemOffset={setCurrentPage}
                  itemOffset={CurrentPage}
                  limit={limit}
                />
              </div>
            </div>
          )}
          {/* {<Footer/>} */}

          {/* <ViewData id={viewAssetId} setViewAssetId={setViewAssetId} /> */}
          {/* <ForkliftDetailView id={viewAssetId} setViewAssetId={setViewAssetId} />  */}

          {/* Create Asset Modal */}
          {role === "admin" ||
            role === "asset_manager" ||
            role === "customer_manager" ? (
            <>
              {" "}
              <CreateAssetModal show={showModal} onClose={setShowModal} />
            </>
          ) : (
            <CreateWarehouseModal show={showModal} onClose={setShowModal} />
          )}
          {role === "admin" ||
            (role === "asset_manager" && (
              <ViewReport showModal={showReport} setShowModal={setShowReport} />
            ))}
          {showSalesModal && (
            <ViewSales
              showModal={showSalesModal}
              setShowModal={setShowSalesModal}
            />
          )}
        </div>
      </div>

      {/* Upload Error Modal */}

      {showUploadErrorModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-900">
                {t("uploadBookValueModel.uploadErrorsTitle") ||
                  "Assets Not Uploaded"}
              </h2>
              <button
                onClick={exportUploadErrorsToPDF}
                disabled={isExportingPDF}
                className={`flex items-center gap-2 font-bold py-2 px-4 rounded transition-colors ${
                  isExportingPDF
                    ? "bg-gray-400 text-white cursor-not-allowed"
                    : "bg-blue-500 hover:bg-blue-700 text-white"
                }`}
              >
                {isExportingPDF ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    Exporting...
                  </>
                ) : (
                  <>
                    <Download className="h-4 w-4" />
                    Export PDF
                  </>
                )}
              </button>
              <button
                onClick={() => setShowUploadErrorModal(false)}
                className="text-gray-400 hover:text-gray-600 focus:outline-none"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <div>
              {/* Show updated assets count */}
              {updatedAssets.length > 0 && (
                <div className="mb-2 text-green-700 flex items-center gap-2">
                  {updatedAssets.length}{" "}
                  {updatedAssets.length === 1
                    ? "asset updated"
                    : "assets updated"}
                  <CheckCircle className="h-4 w-4 text-green-500" />
                </div>
              )}
              {/* Show not found assets title */}
              <p className="mb-2 text-gray-700">
                {t("uploadBookValueModel.uploadErrorsMsg") ||
                  "The following assets could not be uploaded:"}
              </p>
              <div className="flex items-center font-semibold border-b pb-1 mb-1">
                <span className="w-1/6 whitespace-nowrap">
                  {t("AssetDashboard.serialNo") || "Serial No"}
                </span>
                <span className="w-5/6"></span>
              </div>
              {/* Show not found assets */}
              <ul className="mb-4">
                {uploadErrors.map((assetId) => (
                  <li
                    key={assetId}
                    className="flex items-center justify-between border-b py-1"
                  >
                    <span>{assetId}</span>
                    <button
                      onClick={() => removeUploadError(assetId)}
                      className="text-red-500 hover:text-red-700"
                      title="Remove"
                    >
                      <X className="h-4 w-4" />
                    </button>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => setShowUploadErrorModal(false)}
                className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
              >
                {t("common.close") || "Close"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Custom Modal */}
      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="modal-delete">
            <p>{t("assets.messages.deleteConfirm")}</p>
            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button className="confirm-btn" onClick={confirmDeleteAsset}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AssetManagerDashboard;
